import React, { Suspense, memo } from 'react';
const CondensedMobileView = React.lazy(() => import('src/common/refactoredComponents/condensedMobileView/CondensedMobileView'));
import { Header } from './CondensedMobileViewItem.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import TrashCanGrey from 'src/assets/images/trash-can-grey.svg';
import { LARGE_TEXT_PX,  TITLE_FONT_COLOR, SEMANTIC_TEXT_PX, GREY_PRODUCT_LIST_COLOR, WHITE_FONT_COLOR, FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';
import { getTotalCount } from 'src/utils/util';

const CondensedMobileViewItems = ({
    itemImplant = [],
    itemInstrument = [],
    section,
    cartPage,
    isFromConsignmentAdd,
    isOrderDetailTab,
    t,
    marginOnMediumDeviceSets,
    marginOnLargeDeviceSets,
    marginOnMobileDeviceSets,
    minWidthSets,
    marginSets,
    itemCardsContainerMinMobWidthSets,
    isOrderScreen,
    showCheckBox,
    isCartScreenOrProductGuide,
    expandedProducts,
    expandedProductsItemList,
    toggleProduct,
    toggleProductItemList,
    isEquityTemp,
    isEquity,
    isQuickOrder,
    orderType,
    handleSetItemClick,
    removeCounter,
    addCounter,
    setsQuantityCheck,
    handleLocationChange,
    deleteProduct,
    handleSetSelection,
    isReviewSubmitScreen,
    isTemplateDetail,
    isSurgery,
    isConsignmentAdd,
    isEquityTemplate,
    isExtraItem,
    reviewScreen,
    isShippingScreen,
    minHeight,
    updateProductQuantity,
    isFromSurgeryTemplate,
    isReviewSubmitScreenEquity,
    inventoryShipping,
    marginRight,
    isQuickOrderEquityTemplate = false,
    isEquityTemplateBundlePopup = false,
    isFromEquity = false,
    onEmptyCategory,
}) => {
    const showCategoryDelete =
        cartPage && typeof onEmptyCategory === 'function';
    const renderCategoryClearButton = (category, testIdSuffix) => {
        if (!showCategoryDelete) return null;
        return (
            <Button
                id={`category-delete-${testIdSuffix}`}
                data-testid={`category-delete-${testIdSuffix}`}
                aria-label={t('scheduleSurgery.cart.removeAllInCategoryAria')}
                show={true}
                clicked={() => onEmptyCategory(category)}
                backgroundColor={'transparent'}
                border={'none'}
                mbBorder={'none'}
                activeBorder={'none'}
                color={'#4C4C6C'}
                fontSize={'10px'}
                fontFamily={FONT_FAMILY_DEMI}
                height={'auto'}
                mobileHeight={'auto'}
                width={'auto'}
                mobileWidth={'auto'}
                padding={'0'}
                mbPadding={'0'}
                margin={'0 12px 0 auto'}
                mobileMargin={'0 12px 0 auto'}
                borderRadius={'0'}
            >
                <img
                    src={TrashCanGrey}
                    alt=""
                    style={{ height: '12px', width: '12px', display: 'block', marginRight: '4px' }}
                />
                <span>{t('common.ClearSection')}</span>
            </Button>
        );
    };
    return (
        <Suspense fallback={<div>{t('common.loadingText')}</div>}>
            <>
                {(itemImplant?.length > 0 || itemInstrument?.length > 0) &&
                    !(section == 'template') &&
                    (!cartPage || isFromConsignmentAdd) &&
                    !isOrderDetailTab && (
                        <Header
                            backgroundColor={WHITE_FONT_COLOR}
                            fontSize={LARGE_TEXT_PX}
                            marginTop={reviewScreen ? '10px' : isFromConsignmentAdd ? '0px' : '10px'}
                            isFromConsignmentAdd={isFromConsignmentAdd}
                        >
                            {isExtraItem ? t('scheduleSurgery.Shipping.TissueServices.extraItems') : t('common.itemsLabel')} (
                            {isOrderScreen
                                ? getTotalCount(
                                      itemImplant?.filter(
                                          (d) => d?.status !== 'キャンセル' && d?.status?.toLowerCase() !== 'cancel'
                                      )
                                  ) +
                                  getTotalCount(
                                      itemInstrument?.filter(
                                          (d) => d?.status !== 'キャンセル' && d?.status?.toLowerCase() !== 'cancel'
                                      )
                                  )
                                : itemImplant.length + itemInstrument.length}
                            )
                        </Header>
                    )}
                {!isOrderDetailTab && itemImplant?.length > 0 && !isQuickOrderEquityTemplate && (
                    <Header>
                        {t('common.implants')} (
                        {isOrderScreen
                            ? getTotalCount(
                                  itemImplant?.filter(
                                      (d) => d?.status !== 'キャンセル' && d?.status?.toLowerCase() !== 'cancel'
                                  )
                              )
                            : getTotalCount(itemImplant)}
                        )
                        {renderCategoryClearButton('itemImplant', 'item-implant')}
                    </Header>
                )}
                {itemImplant?.map((item, index) => (
                    <div key={index} style={{ width: '100%' }}>
                        <CondensedMobileView
                            isEquityTemplate={isEquityTemplate}
                            orderType={orderType}
                            showCheckBox={showCheckBox}
                            isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                            onToggle={isOrderScreen
                                ? isOrderDetailTab
                                    ? () => toggleProductItemList(item?.productKey)
                                    : () => toggleProduct(item?.productKey)
                                : () => toggleProduct(item?.productKey)}
                            isExpanded={isOrderScreen
                                ? isOrderDetailTab
                                    ? expandedProductsItemList?.has(item?.productKey)
                                    : expandedProducts?.has(item?.productKey)
                                : expandedProducts?.has(item?.productKey)}
                            cartPage={cartPage}
                            isEquityTemp={isEquityTemp}
                            marginOnMediumDevice={marginOnMediumDeviceSets}
                            marginOnLargeDevice={marginOnLargeDeviceSets}
                            marginOnMobileDevice={marginOnMobileDeviceSets}
                            key={`${item.cfn}-${0}`}
                            isCounterButton={true}
                            minWidth={minWidthSets}
                            setOrItemDetails={item}
                            removeCount={() => item?.quantity > 0 && removeCounter(item?.productKey, item?.isSet, item)}
                            addCount={() => isSurgery ? setsQuantityCheck(item) && addCounter(item) : addCounter(item)}
                            cardType={'items'}
                            count={item.count}
                            showBrand={true}
                            showType={true}
                            margin={marginSets}
                            setNameColor={TITLE_FONT_COLOR}
                            setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                            setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                            itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidthSets}
                            onSetItemClick={handleSetItemClick}
                            clickable={true}
                            basePrice={item?.basePrice}
                            extPrice={item?.extPrice}
                            productSearchFlag={true}
                            productType={'Cart'}
                            isCart={true}
                            setIsQuantityMoreThan50={true}
                            description={item.description}
                            background={index % 2 !== 0 ? GREY_PRODUCT_LIST_COLOR : ''}
                            section={section}
                            deleteProduct={deleteProduct}
                            isEquity={isEquity}
                            isFromEquity={isFromEquity}
                            isTemplateDetail={isTemplateDetail}
                            isFromSurgeryTemplate={isFromSurgeryTemplate}
                            isSurgery={isSurgery}
                            isReviewSubmitScreen={isReviewSubmitScreen}
                            isOrderScreen={isOrderScreen}
                            isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
                            isConsignmentAdd={isConsignmentAdd}
                            reviewScreen={reviewScreen}
                            isShippingScreen={isShippingScreen}
                            isOrderDetailTab={isOrderDetailTab}
                            handleLocationChange={handleLocationChange}
                            inventoryShipping={inventoryShipping}
                            handleSetSelection={handleSetSelection}
                            minHeight={minHeight}
                            updateProductQuantity={updateProductQuantity}
                            marginRight={marginRight}
                            isEquityTemplateBundlePopup={isEquityTemplateBundlePopup}
                        />
                    </div>
                ))}
                {!isOrderDetailTab && itemInstrument?.length > 0 && !isQuickOrderEquityTemplate && (
                    <Header
                        mbMarginTop={'0px'}
                    >
                        {t('common.instruments')} (
                        {isOrderScreen
                            ? getTotalCount(
                                  itemInstrument?.filter(
                                      (d) => d?.status !== 'キャンセル' && d?.status?.toLowerCase() !== 'cancel'
                                  )
                              )
                            : getTotalCount(itemInstrument)}
                        )
                        {renderCategoryClearButton('itemInstrument', 'item-instrument')}
                    </Header>
                )}
                {itemInstrument?.map((item, index) => (
                    <div key={index} style={{ width: '100%' }}>
                        <CondensedMobileView
                            isEquityTemplate={isEquityTemplate}
                            orderType={orderType}
                            showCheckBox={showCheckBox}
                            isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                            onToggle={isOrderScreen
                                ? isOrderDetailTab
                                    ? () => toggleProductItemList(item?.productKey)
                                    : () => toggleProduct(item?.productKey)
                                : () => toggleProduct(item?.productKey)}
                            isExpanded={isOrderScreen
                                ? isOrderDetailTab
                                    ? expandedProductsItemList?.has(item?.productKey)
                                    : expandedProducts?.has(item?.productKey)
                                : expandedProducts?.has(item?.productKey)}
                            cartPage={cartPage}
                            isEquityTemp={isEquityTemp}
                            marginOnMediumDevice={marginOnMediumDeviceSets}
                            marginOnLargeDevice={marginOnLargeDeviceSets}
                            marginOnMobileDevice={marginOnMobileDeviceSets}
                            key={`${item.cfn}-${0}`}
                            isCounterButton={true}
                            minWidth={minWidthSets}
                            setOrItemDetails={item}
                            removeCount={() => item?.quantity > 0 && removeCounter(item?.productKey, item?.isSet, item)}
                            addCount={() => isSurgery ? setsQuantityCheck(item) && addCounter(item) : addCounter(item)}
                            cardType={'items'}
                            count={item.count}
                            showBrand={true}
                            showType={true}
                            marginSets={marginSets}
                            setNameColor={TITLE_FONT_COLOR}
                            setNameFontSizeMobile={SEMANTIC_TEXT_PX}
                            setNameFontSizeDesktop={SEMANTIC_TEXT_PX}
                            itemCardsContainerMinMobWidthSets={itemCardsContainerMinMobWidthSets}
                            onSetItemClick={handleSetItemClick}
                            clickable={true}
                            basePrice={item?.basePrice}
                            extPrice={item?.extPrice}
                            productSearchFlag={true}
                            productType={'Cart'}
                            isCart={true}
                            setIsQuantityMoreThan50={true}
                            description={item.description}
                            background={index % 2 !== 0 ? GREY_PRODUCT_LIST_COLOR : ''}
                            section={section}
                            deleteProduct={deleteProduct}
                            isEquity={isEquity}
                            isFromEquity={isFromEquity}
                            isQuickOrder={isQuickOrder}
                            isTemplateDetail={isTemplateDetail}
                            isFromSurgeryTemplate={isFromSurgeryTemplate}
                            isSurgery={isSurgery}
                            isReviewSubmitScreen={isReviewSubmitScreen}
                            isOrderScreen={isOrderScreen}
                            isReviewSubmitScreenEquity={isReviewSubmitScreenEquity}
                            isConsignmentAdd={isConsignmentAdd}
                            reviewScreen={reviewScreen}
                            isShippingScreen={isShippingScreen}
                            isOrderDetailTab={isOrderDetailTab}
                            handleLocationChange={handleLocationChange}
                            inventoryShipping={inventoryShipping}
                            handleSetSelection={handleSetSelection}
                            minHeight={minHeight}
                            updateProductQuantity={updateProductQuantity}
                            marginRight={marginRight}
                            isEquityTemplateBundlePopup={isEquityTemplateBundlePopup}
                        />
                    </div>
                ))}
            </>
        </Suspense>
    );
};
export default memo(CondensedMobileViewItems);
